import { Component, OnInit, Input, ViewChild } from "@angular/core";

import { Product } from "../../../classes/product";

@Component({
  selector: "app-product-box-one",
  templateUrl: "./product-box-one.component.html",
  styleUrls: ["./product-box-one.component.scss"],
})
export class ProductBoxOneComponent implements OnInit {
  products: any = [];

  @Input() product: Product;
  @Input() currency: any; // Default Currency
  @Input() thumbnail: boolean = false; // Default False
  @Input() onHowerChangeImage: boolean = true; // Default False
  @Input() cartModal: boolean = false; // Default False
  @Input() loader: boolean = false;

  public ImageSrc: string;

  constructor() {}

  ngOnInit(): void {
    console.log(this.product);

    if (this.loader) {
      setTimeout(() => {
        this.loader = false;
      }, 2000); // Skeleton Loader
    }
  }

  // Get Product Color
}
